import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({ settings: {}, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data || {});
    } catch (e) {
      console.warn("settings load failed", e);
      setSettings({});
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Inject Google Analytics if a tracking ID is provided
  useEffect(() => {
    const id = settings.ga_tracking_id;
    if (!id) return;
    if (document.getElementById("svn-ga-script")) return;
    const s1 = document.createElement("script");
    s1.id = "svn-ga-script";
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
    document.head.appendChild(s1);
    const s2 = document.createElement("script");
    s2.id = "svn-ga-config";
    s2.text = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${id}');`;
    document.head.appendChild(s2);
  }, [settings.ga_tracking_id]);

  const value = useMemo(() => ({ settings, refresh }), [settings, refresh]);

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
